module.exports = __webpack_public_path__ + "img/icon_tips1.0a539c85.png";